import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./valuation-block-value-adjustments.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./valuation-block-value-adjustments.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { BehaviorSubject, map } from "rxjs";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { ValuationBlockValueAdjustmentConfigHeadingLookup } from "./shared/enums/pv-valuation-block-value-adjustments.enum";
import { AppControllerService } from "../../../../../app-controller.service";
import { AlertType } from "../../../../../shared/models/alert";
import { ValuationBlockValueAdjustmentsConstants } from "./valuation-block-value-adjustments.constants";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { ViewApplicationService } from "../../../view-application.service";
import { ValuationBlockValueAdjustmentsService } from "./shared/services/valuation-block-value-adjustments.service";
let ValuationBlockValueAdjustmentsComponent = class ValuationBlockValueAdjustmentsComponent extends ApplicationBaseComponent {
    appControllerService;
    changeDetectorRef;
    route;
    viewApplicationService;
    aflaModuleStrategyService;
    valuationBlockValueAdjustmentService;
    routerParamsService;
    dataSource = new BehaviorSubject([]);
    selectedValueAdjustmentsInTable;
    tableMapper;
    addLabel = SharedConstants.ADD_LABEL;
    editLabel = SharedConstants.EDIT_LABEL;
    deleteLabel = SharedConstants.DELETE_LABEL;
    inheritDataLabel = ValuationBlockValueAdjustmentsConstants.INHERIT_DATA_LABEL;
    valueAdjustmentsInheritedSuccessMsg = ValuationBlockValueAdjustmentsConstants.VALUE_ADJUSTMENTS_SUCCESSFULLY_INHERITED_MSG;
    valuationBlockId;
    getPropertyValuationValuationBlockValueAdjustmentsSubscription;
    constructor(appControllerService, changeDetectorRef, route, viewApplicationService, aflaModuleStrategyService, valuationBlockValueAdjustmentService, routerParamsService) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.appControllerService = appControllerService;
        this.changeDetectorRef = changeDetectorRef;
        this.route = route;
        this.viewApplicationService = viewApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.valuationBlockValueAdjustmentService = valuationBlockValueAdjustmentService;
        this.routerParamsService = routerParamsService;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initializeColumnToObjectMapping();
    }
    arrayReturned(array) {
        this.selectedValueAdjustmentsInTable = array;
    }
    ngAfterViewInit() {
        this.getValuationBlockId();
    }
    handleRouteChange() {
    }
    initializeColumnToObjectMapping() {
        this.tableMapper = ValuationBlockValueAdjustmentConfigHeadingLookup;
    }
    getValuationBlockId() {
        const params = {
            $select: `id`, $filter: `jobId eq ${this.jobID} and moduleId eq ${this.moduleID} and deleted eq false`,
        };
        this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params).pipe(map((response) => {
            return response.value;
        }))
            .subscribe({
            next: (valuationBlockIdObject) => {
                this.setValuationBlockId(valuationBlockIdObject?.[0]?.id);
                if (this.valuationBlockId) {
                    this.geValuationBlockValueAdjustments();
                }
                else {
                    this.appControllerService.showMessage("The ID of the current valuation block could not be found, please contact your system administrator", AlertType.Error);
                }
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage("valuation block ID", error, CRUDOperation.Get);
            }
        });
    }
    setValuationBlockId(valuationRunId) {
        this.valuationBlockId = valuationRunId;
    }
    geValuationBlockValueAdjustments() {
        const params = {
            $filter: `valuationBlockId eq ${this.valuationBlockId}`,
        };
        this.getPropertyValuationValuationBlockValueAdjustmentsSubscription = this.valuationBlockValueAdjustmentService.getPropertyValuationValuationBlockValueAdjustments(params).subscribe({
            next: (addValuationBlockValueAdjustments) => {
                this.dataSource.next(addValuationBlockValueAdjustments);
                this.changeDetectorRef.detectChanges();
            }, error: err => {
                this.appControllerService.handleServerErrorMessage("valuation block value adjustments", err, CRUDOperation.Get);
            }
        });
    }
    static ctorParameters = () => [
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: ActivatedRoute },
        { type: ViewApplicationService },
        { type: AflaModuleStrategyService },
        { type: ValuationBlockValueAdjustmentsService },
        { type: RouterParamsService }
    ];
};
ValuationBlockValueAdjustmentsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-valuation-block-value-adjustments",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ValuationBlockValueAdjustmentsComponent);
export { ValuationBlockValueAdjustmentsComponent };
